import { Btn, H6, H2, H3, LI, P, UL, H4 } from '../../../../AbstractElements';
import { MarginBottom, Renew, RenewSubscription, Subscribe, Upgrade, Upgradenow, month } from '../../../../Constant';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { getMasterDataToken, postMasterToken } from '../../../../Utils/restUtils';
import { getPackageDet, postSubscription } from '../../../../CommonUrl';
import { useNavigate } from 'react-router';
import HandleHomePageError from '../../../Common/ErrorImport/SignError';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setSubStatus, setSubscriptionDetails } from '../../../../Redux/Reducer';

const Standards = (props) => {
    const priceDetails = props.details;
    const authState = props.auth;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setloading] = useState(false);
    const [color, setcolor] = useState('');
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        if (priceDetails?.subscription_days_left >= -10 && priceDetails?.subscription_days_left <= 1) {
            setcolor('red')
        } else if (priceDetails?.subscription_days_left <= 10) {
            setcolor('orange')
        } else {
            setcolor('blue')
        }
    }, [priceDetails]);

    useEffect(() => {
        if (isHovered || !priceDetails?.packages?.length) return;
        const interval = setInterval(() => {
            if (scrollContainerRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
                if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    scrollContainerRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    scrollContainerRef.current.scrollBy({ left: 340, behavior: 'smooth' });
                }
            }
        }, 3000);
        return () => clearInterval(interval);
    }, [isHovered, priceDetails]);

    const handleScroll = (direction) => {
        if (scrollContainerRef.current) {
            const scrollAmount = 340;
            scrollContainerRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const submitSubscription = async (item) => {
        setloading(true);
        const integerNumber = Math.floor(item.price);
        if (integerNumber === 0) {
            const postRequest = { package_id: item.id, industry_type_id: authState.industryId, company_id: props.companyId, company: '' }
            const response = await postMasterToken(postSubscription, postRequest);
            if (response.status === 200) {
                const response = await getMasterDataToken(getPackageDet);
                if (response.status === true) {
                    const packagetDetails = { packageName: response.data.package_name, packageExp: response.data.package_expire_in }
                    dispatch(setSubscriptionDetails(packagetDetails));
                    dispatch(setSubStatus(packagetDetails));
                    if (authState.subStatus !== null || authState.subStatus.length !== 0) {
                        navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
                    }
                    toast.success(response.data.message);
                }
                else {
                    HandleHomePageError(navigate, response.status)
                    setloading(false)
                }
                setloading(false)
            }
            else {
                HandleHomePageError(navigate, response.status)
            }
        } else {
            navigate('/applyCoupon', { state: { package_id: item, company_id: props.companyId } });
        }
        setloading(false);
    }

    return (
        <Fragment>
            {loading && <Transparentspinner />}
            <CardBody className='pt-2'>
                {priceDetails?.current_plan != 'None' && (
                    <div>
                        <div className={`mb-3 p-3 text-white bg-subscription-${color} `} >
                            {props.upgradeText && <div><strong>{props.upgradeText}</strong><br /></div>}
                            {
                                priceDetails?.subscription_days_left > 0 ?
                                    <>
                                        <strong>Note:</strong><span>Your current package ends on</span> <span className="note-date">{priceDetails?.subscription_end_date ?? ''}</span>.{priceDetails?.subscription_days_left < 30 && <span className="note-days-left"> Only {priceDetails?.subscription_days_left ?? ''} days left.</span>}
                                    </>
                                    :
                                    <>
                                        <strong>Note:</strong><span>Your current package has been expired</span>
                                    </>
                            }
                        </div>
                    </div>
                )}
                <div 
                    className="pricing-carousel-wrapper"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <button
                        type="button"
                        className="pricing-carousel-btn prev"
                        onClick={() => handleScroll('left')}
                        aria-label="Previous"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
                    </button>
                    <div className="pricing-carousel-container" ref={scrollContainerRef}>
                        <Row className="pricing-content pricing-col">
                            {
                                priceDetails?.packages?.map((item, index) => {
                                    const integerNumber = Math.floor(item.price);
                                    const isPopular = index === 2 || item.name?.toLowerCase() === 'growth' || item.name?.toLowerCase() === 'premium';
                                    const hasFreeTrialDays = item.free_trial_days !== undefined && item.free_trial_days !== null && Number(item.free_trial_days) !== 0;
                                    const displayDuration = hasFreeTrialDays ? `${item.free_trial_days} days` : item.duration;

                                    return (
                                        <Col md='4' key={index}>
                                            <Card className={`pricing-new-card `}>
                                                <div className="pricing-header">
                                                    <H2>{item.name}</H2>
                                                    {item.description && <div className="subtitle">{item.description}</div>}
                                                    <div className="price-display">
                                                        {/* {integerNumber !== 0 && item.mrp && <span className="original-price">{item.currency}{item.mrp}</span>} */}
                                                        <H3>{item.currency} {item.price}</H3>
                                                        <span className="duration">/{displayDuration}</span>
                                                    </div>
                                                    {/* {integerNumber !== 0 && item.setup_cost !== undefined && (
                                                        <div className="setup-cost">
                                                            Setup Cost <span className="setup-cost-amount">{item.currency} {item.setup_cost}</span>
                                                        </div>
                                                    )} */}
                                                    {integerNumber === 0 && <div className="setup-cost">No credit card required</div>}
                                                </div>

                                                <div className="connection-box">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 005.656-5.656l-1.1 1.1"></path></svg>
                                                    <span>{`Max service accounts ${item.max_connection}`}</span>
                                                </div>

                                                <div className="whats-included">WHAT'S INCLUDED</div>

                                                {(() => {
                                                    const sections = [];
                                                    let currentSection = { title: null, items: [] };

                                                    if (item.features) {
                                                        item.features.split('\n').forEach(feature => {
                                                            if (!feature.trim()) return;
                                                            if (feature.startsWith('**')) {
                                                                if (currentSection.items.length > 0 || currentSection.title) {
                                                                    sections.push(currentSection);
                                                                }
                                                                currentSection = { title: feature.replace('**', '').trim(), items: [] };
                                                            } else {
                                                                currentSection.items.push(feature);
                                                            }
                                                        });
                                                        if (currentSection.items.length > 0 || currentSection.title) {
                                                            sections.push(currentSection);
                                                        }
                                                    }

                                                    return sections.map((section, sIndex) => (
                                                        <React.Fragment key={`section-${sIndex}`}>
                                                            {section.title && (
                                                                <>
                                                                    <hr style={{ margin: '5px 0 10px 0', borderColor: '#e2e8f0' }} />
                                                                    <div className="whats-included" style={{ marginTop: '5px' }}>{section.title.toUpperCase()}</div>
                                                                </>
                                                            )}
                                                            <ul className="pricing-features" style={{ marginBottom: sIndex < sections.length - 1 ? '0' : 'inherit' }}>
                                                                {section.items.map((feature, fIndex) => (
                                                                    <li key={`feature-${sIndex}-${fIndex}`}>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                        <span>{feature}</span>
                                                                    </li>
                                                                ))}
                                                                {sIndex === 0 && (
                                                                    <li>
                                                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                        <span>Duration: {displayDuration}</span>
                                                                    </li>
                                                                )}
                                                            </ul>
                                                        </React.Fragment>
                                                    ));
                                                })()}

                                                <div className="pricing-footer">
                                                    {
                                                        priceDetails?.current_plan === 'None' ?
                                                            <button className='btn-pricing' onClick={() => submitSubscription(item)}>
                                                                {integerNumber === 0 ? 'Start Free Trial' : Subscribe}
                                                            </button> :
                                                            <button
                                                                disabled={priceDetails?.subscription_days_left >= 30 && item?.id === priceDetails?.current_plan_id}
                                                                className='btn-pricing'
                                                                onClick={() => submitSubscription(item)}
                                                            >
                                                                {
                                                                    item?.id === priceDetails?.current_plan_id
                                                                        ? (priceDetails?.subscription_days_left >= 30 ? 'Current Plan' : 'Renew')
                                                                        : (integerNumber === 0 ? 'Start Free Trial' : Upgrade)
                                                                }
                                                            </button>
                                                    }
                                                </div>
                                            </Card>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                    <button
                        type="button"
                        className="pricing-carousel-btn next"
                        onClick={() => handleScroll('right')}
                        aria-label="Next"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
                    </button>
                </div>
            </CardBody>
        </Fragment>
    );
};
export default Standards;

